module.exports = __webpack_public_path__ + "static/img/banner.7f2a056.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/banner.png
// module id = RDT6
// module chunks = 2